import {
  IntegrationStatusFilters,
  sortFilter,
} from '../constants/integrationsList.js';
import { useIntegrationsIndexRouteApi } from './useIntegrationsRouteApi.js';

export const useIntegrationsFilter = () => {
  const indexRoute = useIntegrationsIndexRouteApi();
  const navigate = indexRoute.useNavigate();

  const {
    sort = sortFilter.connectionType,
    status = IntegrationStatusFilters.all,
    search = '',
    category = '',
    channel = '',
  } = indexRoute.useSearch();

  return {
    search,
    status: status as IntegrationStatusFilters,
    sort: sort as sortFilter,
    categoryUrl: category,
    channelUrl: channel,
    categoryArray: category ? category.split(',') : [],
    channelArray: channel ? channel.split(',') : [],
    navigate,
  };
};
